// #371: the JSON Schema that locks the shape of a catalog test-definition
// file (docs/score/2023_tests/*.json + docs/score/fei_tests/*.json). Imported
// straight from its canonical repo location rather than duplicated into this
// package: Vite resolves this across the workspace boundary the same way it
// already resolves workspace packages (its default dev-server fs.allow root
// is the monorepo root, found by walking up to the nearest lockfile/.git,
// see vite's searchForWorkspaceRoot), and a static JSON import gets inlined
// at build time, so there is no runtime fs/network dependency either.
//
// This is the SAME schema apps/score-api/scripts/import-catalog-defs.mjs
// treats as authoritative when it loads the sibling *.json test-defs it
// describes into the score-catalog DynamoDB table (packages/score-common/
// scripts/build-catalog.mjs used to bundle them into a build-time
// score-common/catalog module instead, retired in #1665); this editor is
// the human-facing counterpart, for hand-editing one def's values without
// touching the source PDF.
import rawSchema from "../../../../docs/score/2023_tests/schema.json";

// RJSF's ajv8 validator only needs the schema keywords (type/properties/
// required/additionalProperties/oneOf/...): it doesn't need to resolve
// $schema/$id against the network, but stripping them avoids ajv trying to
// treat this as a schema document it must register under those URIs.
// eslint-disable-next-line no-unused-vars
const { $schema, $id, ...rest } = rawSchema;

/** Test-definition JSON Schema, locked (field names come from here, only
 * the values a form renders against it are editable). */
export const testDefSchema = rest;
